module.exports = __webpack_public_path__ + "img/bull_lol5.da871138.png";